import { AppBar, Dialog, DialogContent, Toolbar, Typography } from '@material-ui/core';
import { notificationWebPushDialogSelector } from 'app/main/apps/webPush/ducks/webPush.selector';
import { setNotificationWebPushDialog } from 'app/main/apps/webPush/ducks/webPush.slice';
import { WebPushSubscriptionInDTO } from 'app/main/apps/webPush/type';
import DialogCloseButton from 'app/main/design-system/components/DialogCloseButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ActivateNotification from './ActivateNotification';
import NotificationSettings from './NotificationSettings';

interface WebPushNotificationDialogProps {
  subscription?: WebPushSubscriptionInDTO;
}

const WebPushNotificationDialog: React.FC<WebPushNotificationDialogProps> = ({ subscription }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isOpen } = useSelector(notificationWebPushDialogSelector);

  return (
    <Dialog
      open={isOpen}
      onClose={() => dispatch(setNotificationWebPushDialog({ isOpen: false }))}
      keepMounted
      className="m-8 sm:m-24"
      PaperProps={{ className: 'rounded-8' }}
      aria-modal="true"
    >
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <Typography variant="h6">{t('notification.dialog.title', { ns: 'notification' })}</Typography>
          <DialogCloseButton onClose={() => dispatch(setNotificationWebPushDialog({ isOpen: false }))} />
        </Toolbar>
      </AppBar>
      <DialogContent>
        {subscription ? <NotificationSettings subscription={subscription} /> : <ActivateNotification />}
      </DialogContent>
    </Dialog>
  );
};

export default WebPushNotificationDialog;
